/* src/app/shared/components/popovers/configuration-popover/configuration-popover.component.scss */
ion-label {
  width: fit-content;
  font-size: 16px !important;
  font-weight: 500;
}
.compact-item ion-icon {
  margin-inline-end: 14px !important;
}
.compact-item ion-label {
  margin-inline-start: 0 !important;
}
/*# sourceMappingURL=configuration-popover.component-ONA5Y6FT.css.map */
